import styled from "styled-components";

export const ModalHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 24px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  line-height: 1.25;
  color: ${({ theme }) => theme.colors.interfaceText500 || theme.colors.interfaceTextPrimary};
  flex: 1;
  min-width: 0;
`;

export const ModalCloseButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  margin: 0;
  padding: 0;
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0.7;
  color: ${({ theme }) => theme.colors.interfaceGray400 || "#6B7280"};
  flex-shrink: 0;

  &:hover {
    opacity: 1;
    background: ${({ theme }) => theme.colors.interfacePure100 || "#F3F4F6"};
  }
`;

export const ModalMessage = styled.p`
  margin: 0 0 32px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.5;
  color: ${(props: any) => props.theme.colors.c797979};
`;

export const ModalActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
`;

export const BtnSecondary = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  gap: 6px;
  padding: 8px 16px;
  height: 40px;
  border-radius: 6px;
  border: 2px solid ${(props: any) => props.theme.colors.interfaceText400};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  font-weight: 500;
  color: ${(props: any) => props.theme.colors.interfaceText400};
  white-space: nowrap;
`;

export const BtnPrimary = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 0;
  gap: 8px;
  padding: 8px 16px;
  height: 40px;
  border-radius: 6px;
  background: ${({ theme }) => theme.colors.primaryRed400};
  color: ${(props: any) => props.theme.colors.pureWhite};
  border: none;
  font-weight: 600;
  cursor: pointer;
`;
